export const SpectrumLine = ({ className = "" }) => (
  <div
    aria-hidden="true"
    data-testid="spectrum-line"
    className={`spectrum-line ${className}`}
  />
);
